/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SmtpServerInfo model module.
 * @module model/SmtpServerInfo
 * @version V1
 */
class SmtpServerInfo {
    /**
     * Constructs a new <code>SmtpServerInfo</code>.
     * @alias module:model/SmtpServerInfo
     */
    constructor() { 
        
        SmtpServerInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SmtpServerInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SmtpServerInfo} obj Optional instance to populate.
     * @return {module:model/SmtpServerInfo} The populated <code>SmtpServerInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SmtpServerInfo();

            if (data.hasOwnProperty('userName')) {
                obj['userName'] = ApiClient.convertToType(data['userName'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('serverAddress')) {
                obj['serverAddress'] = ApiClient.convertToType(data['serverAddress'], 'String');
            }
            if (data.hasOwnProperty('serverPort')) {
                obj['serverPort'] = ApiClient.convertToType(data['serverPort'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SmtpServerInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SmtpServerInfo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['userName'] && !(typeof data['userName'] === 'string' || data['userName'] instanceof String)) {
            throw new Error("Expected the field `userName` to be a primitive type in the JSON string but got " + data['userName']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['serverAddress'] && !(typeof data['serverAddress'] === 'string' || data['serverAddress'] instanceof String)) {
            throw new Error("Expected the field `serverAddress` to be a primitive type in the JSON string but got " + data['serverAddress']);
        }

        return true;
    }


}



/**
 * @member {String} userName
 */
SmtpServerInfo.prototype['userName'] = undefined;

/**
 * @member {String} password
 */
SmtpServerInfo.prototype['password'] = undefined;

/**
 * @member {String} serverAddress
 */
SmtpServerInfo.prototype['serverAddress'] = undefined;

/**
 * @member {Number} serverPort
 */
SmtpServerInfo.prototype['serverPort'] = undefined;






export default SmtpServerInfo;

